// /* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Button from "../../extras/Button";
import { useDispatch, useSelector } from "react-redux";
import Title from "../../extras/Title";
import { getSetting, handleSetting, maintenanceMode, updateSetting } from "../../../redux/slice/settingSlice";
import Input from "../../extras/Input";
import { editData, submitData } from "../../../util/fuction";
import ToggleSwitch from "../../extras/ToggleSwitch";
import { permissionError } from "../../../util/Alert";

const Setting = (props) => {
  const dispatch = useDispatch();
  const { setting } = useSelector((state) => state.setting);
  const hasPermission = useSelector((state) => state.auth.admin.flag);

  const [privacyPolicyLink, setPrivacyPolicyLink] = useState();
  const [tnc, setTnc] = useState();
  const [tax, setTax] = useState();
  const [razorPayId, setRazorPayId] = useState("");
  const [razorSecretKey, setRazorSecretKey] = useState("");
  // box 5
  const [stripePublishableKey, setStripePublishableKey] = useState("");
  const [stripeSecretKey, setStripeSecretKey] = useState("");

  const [currencyName, setCurrencyName] = useState();
  const [currencySymbol, setCurrencySymbol] = useState();
  const [flutterWaveKey, setFlutterWaveKey] = useState();

  const [firebaseKey, setfirebaseKey] = useState();
  const [resendKey, setResendKey] = useState();
  const [person, setPerson] = useState(0);

  const [androidAppVersion, setAndroidAppVersion] = useState();
  const [androidAppLink, setAndroidAppLink] = useState();
  const [iosAppVersion, setIosAppVersion] = useState();
  const [iosAppLink, setIosAppLink] = useState();

  const [paystackPublicKey, setPaystackPublicKey] = useState();
  const [paystackSecretKey, setPaystackSecretKey] = useState();

  const [cashfreeClientId, setCashfreeClientId] = useState();
  const [cashfreeClientSecret, setCashfreeClientSecret] = useState();

  const [paypalClientId, setPaypalClientId] = useState();
  const [paypalSecretKey, setPaypalSecretKey] = useState();

  const [googlePlayEmail, setGooglePlayEmail] = useState("");
  const [googlePlayKey, setGooglePlayKey] = useState("");

  const [nowPaymentApiKey, setNowPaymentApiKey] = useState("");
  const [nowPaymentSandboxKey, setNowPaymentSandboxKey] = useState("");
  const [nowPaymentIpnSecret, setNowPaymentIpnSecret] = useState("");
  const [nowPaymentPayCurrency, setNowPaymentPayCurrency] = useState("");

  const [initialValues, setInitialValues] = useState({});

  const [error, setError] = useState({
    firebaseKey: "",
    resendKey: "",
    privacyPolicyLink: "",
    tnc: "",
    stripePublishableKey: "",
    stripeSecretKey: "",
    razorPayId: "",
    razorSecretKey: "",
    tax: "",
    currencyName: "",
    currencySymbol: "",
    flutterWaveKey: "",
    androidAppVersion: "",
    androidAppLink: "",
    iosAppVersion: "",
    iosAppLink: "",
    paystackPublicKey: "",
    paystackSecretKey: "",
    cashfreeClientId: "",
    cashfreeClientSecret: "",
    paypalClientId: "",
    paypalSecretKey: "",
    googlePlayEmail: "",
    googlePlayKey: "",
    nowPaymentApiKey: "",
    nowPaymentSandboxKey: "",
    nowPaymentIpnSecret: "",
    nowPaymentPayCurrency: "",
  });

  useEffect(() => {
    if (hasPermission) dispatch(getSetting());
  }, [dispatch, hasPermission]);

  useEffect(() => {
    if (setting) {
      setCurrencyName(setting.currencyName);
      setCurrencySymbol(setting.currencySymbol);
      setStripePublishableKey(setting.stripePublishableKey);
      setStripeSecretKey(setting.stripeSecretKey);
      setRazorPayId(setting.razorPayId);
      setRazorSecretKey(setting.razorSecretKey);
      setTax(setting.tax);
      setPrivacyPolicyLink(setting?.privacyPolicyLink);
      setTnc(setting.tnc);
      setFlutterWaveKey(setting.flutterWaveKey);
      setfirebaseKey(JSON.stringify(setting.firebaseKey));
      setResendKey(setting.resendApiKey);
      setAndroidAppVersion(setting?.androidAppVersion);
      setAndroidAppLink(setting?.androidAppLink);
      setIosAppVersion(setting?.iosAppVersion);
      setIosAppLink(setting?.iosAppLink);
      setPaystackPublicKey(setting?.paystackPublicKey);
      setPaystackSecretKey(setting?.paystackSecretKey);
      setCashfreeClientId(setting?.cashfreeClientId);
      setCashfreeClientSecret(setting?.cashfreeClientSecret);
      setPaypalClientId(setting?.paypalClientId);
      setPaypalSecretKey(setting?.paypalSecretKey);
      setGooglePlayEmail(setting?.googlePlayEmail);
      setGooglePlayKey(setting?.googlePlayKey);
      setNowPaymentApiKey(setting?.nowPaymentApiKey);
      setNowPaymentSandboxKey(setting?.nowPaymentSandboxKey);
      setNowPaymentIpnSecret(setting?.nowPaymentIpnSecret);
      setNowPaymentPayCurrency(setting?.nowPaymentPayCurrency);

      setInitialValues({
        privacyPolicyLink: setting?.privacyPolicyLink,
        tnc: setting?.tnc,
        tax: setting?.tax,
        razorPayId: setting?.razorPayId,
        razorSecretKey: setting?.razorSecretKey,
        stripePublishableKey: setting?.stripePublishableKey,
        stripeSecretKey: setting?.stripeSecretKey,
        currencyName: setting?.currencyName,
        currencySymbol: setting?.currencySymbol,
        flutterWaveKey: setting?.flutterWaveKey,
        firebaseKey: JSON.stringify(setting?.firebaseKey),
        resendApiKey: setting?.resendApiKey,
        androidAppVersion: setting?.androidAppVersion,
        androidAppLink: setting?.androidAppLink,
        iosAppVersion: setting?.iosAppVersion,
        iosAppLink: setting?.iosAppLink,
        paystackPublicKey: setting?.paystackPublicKey,
        paystackSecretKey: setting?.paystackSecretKey,
        cashfreeClientId: setting?.cashfreeClientId,
        cashfreeClientSecret: setting?.cashfreeClientSecret,
        paypalClientId: setting?.paypalClientId,
        paypalSecretKey: setting?.paypalSecretKey,
        googlePlayEmail: setting?.googlePlayEmail,
        googlePlayKey: setting?.googlePlayKey,
        nowPaymentApiKey: setting?.nowPaymentApiKey,
        nowPaymentSandboxKey: setting?.nowPaymentSandboxKey,
        nowPaymentIpnSecret: setting?.nowPaymentIpnSecret,
        nowPaymentPayCurrency: setting?.nowPaymentPayCurrency,
      });
    }
  }, [setting]);

  const getChangedFields = (initial, current) => {
  const changed = {};

  Object.keys(current).forEach((key) => {
    if (current[key] !== initial[key]) {
      changed[key] = current[key];
    }
  });

  return changed;
};


  const onsubmit = async (e) => {
    e.preventDefault();
    if (!hasPermission) return permissionError();
    if (
      !privacyPolicyLink ||
      !tnc ||
      !stripePublishableKey ||
      !stripeSecretKey ||
      !razorPayId ||
      !razorSecretKey ||
      !tax ||
      !currencyName ||
      !currencySymbol ||
      !flutterWaveKey ||
      !firebaseKey ||
      !resendKey ||
      !androidAppVersion ||
      !androidAppLink ||
      !iosAppVersion ||
      !iosAppLink ||
      !paystackPublicKey ||
      !paystackSecretKey ||
      !cashfreeClientId ||
      !cashfreeClientSecret ||
      !paypalClientId ||
      !paypalSecretKey ||
       !googlePlayEmail ||
      !googlePlayKey ||
      !nowPaymentApiKey ||
      !nowPaymentSandboxKey ||
      !nowPaymentIpnSecret ||
      !nowPaymentPayCurrency
    ) {
      let error = {};
      if (!privacyPolicyLink) error.privacyPolicyLink = "Privacy Policy Link is required";
      if (!tnc) error.tnc = "T&C is required";
      if (!stripePublishableKey) error.stripePublishableKey = "Stripe Publishable Key is required";
      if (!stripeSecretKey) error.stripeSecretKey = "Stripe Secret Key is required";
      if (!razorPayId) error.razorPayId = "Razor Pay Id is required";
      if (!razorSecretKey) error.razorSecretKey = "Razor Secret Key is required";
      if (!tax) error.tax = "Tax is required";
      if (!currencyName) error.currencyName = "Currency Name is required";
      if (!currencySymbol) error.currencySymbol = "Currency Symbol is required";
      if (!flutterWaveKey) error.flutterWaveKey = "Flutter Wave Key is required";
      if (!firebaseKey) error.firebaseKey = "Firebase Key is required";
      if (!resendKey) error.resendKey = "Resend API Key is required";
      if (!androidAppVersion) error.androidAppVersion = "Android App Version is Required";
      if (!androidAppLink) error.androidAppLink = "Android App Link is Required";
      if (!iosAppVersion) error.iosAppVersion = "IOS App Version is Required";
      if (!iosAppLink) error.iosAppLink = "IOS App Link is Required";
      if (!paystackPublicKey) error.paystackPublicKey = "Paystack Public Key is Required";
      if (!paystackSecretKey) error.paystackSecretKey = "Paystack Secret Key is Required";
      if (!cashfreeClientId) error.cashfreeClientId = "Cashfree Client Id is Required";
      if (!cashfreeClientSecret) error.cashfreeClientSecret = "Cashfree Client Secret is Required";
      if (!paypalClientId) error.paypalClientId = "Paypal Client Id is Required";
      if (!paypalSecretKey) error.paypalSecretKey = "Paypal Secret Key is Required";
      if (!googlePlayEmail) error.googlePlayEmail = "Google Play Email Required";
      if (!googlePlayKey) error.googlePlayKey = "Google Play Key Required";
      if (!nowPaymentApiKey) error.nowPaymentApiKey = "Now Payment API Key Required";
      if (!nowPaymentSandboxKey) error.nowPaymentSandboxKey = "Now Payment Sandbox Key Required";
      if (!nowPaymentIpnSecret) error.nowPaymentIpnSecret = "Now Payment IPN Secret Required";
      if (!nowPaymentPayCurrency) error.nowPaymentPayCurrency = "Now Payment Pay Currency Required";
      return setError({ ...error });
    } else {
      const currentValues = {
  privacyPolicyLink,
  tnc,
  stripePublishableKey,
  stripeSecretKey,
  razorPayId,
  razorSecretKey,
  tax,
  currencyName,
  currencySymbol,
  flutterWaveKey,
  firebaseKey,
  resendApiKey: resendKey,
  androidAppVersion,
  androidAppLink,
  iosAppVersion,
  iosAppLink,
  paystackPublicKey,
  paystackSecretKey,
  cashfreeClientId,
  cashfreeClientSecret,
  paypalClientId,
  paypalSecretKey,
  googlePlayEmail,
  googlePlayKey,
  nowPaymentApiKey,
  nowPaymentSandboxKey,
  nowPaymentIpnSecret,
  nowPaymentPayCurrency,
};
     const data = getChangedFields(initialValues, currentValues);

// 🔐 Optional safety check
if (Object.keys(data).length === 0) {
  return; // nothing changed → no API call
}

const payload = {
  id: setting?._id,
  data,
};

await dispatch(updateSetting(payload)).unwrap();
    }
  };

  const handleSettingSwitch = (id, type) => {
    if (!hasPermission) return permissionError();
    const payload = {
      id,
      type,
    };
    dispatch(handleSetting(payload));
  };

  const handleAppActive = (id) => {
    if (!hasPermission) return permissionError();
    dispatch(maintenanceMode(id));
  };

  const fakeFirebaseJson = {
    type: "service_account",
    project_id: "demo-project-12345",
    private_key_id: "fakeprivatekeyid1234567890abcdef",
    private_key: "-----BEGIN PRIVATE KEY-----\nMIIEvQIBADANBgkqhkiG9w0FAKEFAASCBKcwggSjAgEAAoIBAQDUMMYKEYEXAMPLE\n-----END PRIVATE KEY-----\n",
    client_email: "firebase-adminsdk-abcde@demo-project-12345.iam.gserviceaccount.com",
    client_id: "123456789012345678901",
    auth_uri: "https://accounts.google.com/o/oauth2/auth",
    token_uri: "https://oauth2.googleapis.com/token",
    auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
    client_x509_cert_url: "https://www.googleapis.com/robot/v1/metadata/x509/firebase-adminsdk-abcde%40demo-project-12345.iam.gserviceaccount.com",
    universe_domain: "googleapis.com",
  };

  const renderfnc = () => {
    switch (person) {
      case 0:
        return (
          <div className="col-12 col-md-12 mt-3">
            <div className="settingBoxOuter">
              <div className="settingBoxHeader d-flex justify-content-between">
                <h4>App Setting</h4>
                <div className="inputData">
                  <label className="me-2">Maintenance Mode (use at the time of app maintanance)</label>
                  <ToggleSwitch onClick={() => handleAppActive(setting?._id)} value={setting?.maintenanceMode} />
                </div>
              </div>
              <div className="row">
              <div className="col-6">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="androidAppVersion" className="ms-2 order-1">
                    Android App Version
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="androidAppVersion"
                    value={androidAppVersion}
                    placeholder={hasPermission ? `Enter Android App Version` : "1.0.0"}
                    onChange={(e) => {
                      setAndroidAppVersion(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          androidAppVersion: `Android App Version Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          androidAppVersion: "",
                        });
                      }
                    }}
                  />
                  {error && <p className="errorMessage text-start">{error && error?.androidAppVersion}</p>}
                </div>
              </div>

              <div className="col-6">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="androidAppLink" className="ms-2 order-1">
                    Android App Link
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="androidAppLink"
                    value={androidAppLink}
                    placeholder={hasPermission ? `Enter Android App Link` : "https://androidapplink.com"}
                    onChange={(e) => {
                      setAndroidAppLink(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          androidAppLink: `Android App Link Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          androidAppLink: "",
                        });
                      }
                    }}
                  />
                  {error && <p className="errorMessage text-start">{error && error?.androidAppLink}</p>}
                </div>
              </div>

              <div className="col-6">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="iosAppVersion" className="ms-2 order-1">
                    IOS App Version
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="iosAppVersion"
                    value={iosAppVersion}
                    placeholder={hasPermission ? `Enter IOS App Version` : "1.0.0"}
                    onChange={(e) => {
                      setIosAppVersion(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          iosAppVersion: `IOS App Version Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          iosAppVersion: "",
                        });
                      }
                    }}
                  />
                  {error && <p className="errorMessage text-start">{error && error?.iosAppVersion}</p>}
                </div>
              </div>

              <div className="col-6">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="iosAppLink" className="ms-2 order-1">
                    IOS App Link
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="iosAppLink"
                    value={iosAppLink}
                    placeholder={hasPermission ? `Enter Android App Link` : "https://iosapplink.com"}
                    onChange={(e) => {
                      setIosAppLink(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          iosAppLink: `IOS App Link Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          iosAppLink: "",
                        });
                      }
                    }}
                  />
                  {error && <p className="errorMessage text-start">{error && error?.iosAppLink}</p>}
                </div>
              </div>
              <div className="col-6">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="privacyPolicyLink" className="ms-2 order-1">
                    Privacy Policy Link (redirect user to this link when click on privacy policy in app)
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="privacyPolicyLink"
                    value={privacyPolicyLink}
                    placeholder={hasPermission ? `Enter Privacy policy link` : "https://privacypolicygenerator.com"}
                    onChange={(e) => {
                      setPrivacyPolicyLink(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          privacyPolicyLink: ` privacyPolicyLink Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          privacyPolicyLink: "",
                        });
                      }
                    }}
                  />
                  {error && <p className="errorMessage text-start">{error && error?.privacyPolicyLink}</p>}
                </div>
              </div>
              <div className="col-6">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="tnc" className="ms-2 order-1">
                    Terms and conditions content
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="tnc"
                    placeholder={hasPermission ? `Enter tnc` : "https://termsgenerator.com"}
                    value={tnc}
                    onChange={(e) => {
                      setTnc(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          tnc: ` Terms And Condition Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          tnc: "",
                        });
                      }
                    }}
                  />
                  {error && <p className="errorMessage text-start">{error && error?.tnc}</p>}
                </div>
              </div>
              <div className="col-6 ">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="tax" className="ms-2 order-1">
                    Tax (%)
                  </label>
                  <input
                    type="number"
                    className="rounded-2"
                    id="tax"
                    value={tax}
                    placeholder={hasPermission ? `Enter Tax` : `15%`}
                    onChange={(e) => {
                      setTax(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          tax: ` tax Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          tax: "",
                        });
                      }
                    }}
                  />
                  {error && <p className="errorMessage text-start">{error && error?.tax}</p>}
                </div>
              </div>
              </div>
            </div>
          </div>
        );

      case 1:
        return (
          <>
            <div className="col-12 col-md-6 mt-3 ">
              <div className="settingBoxOuter">
                <div className="settingBoxHeader">
                  <h4>Razor Pay Setting</h4>
                </div>
                <div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Razor Pay Android Active (enable/disable razor pay)</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 1)} value={setting?.isRazorPay} />
                </div>

                <div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Razor Pay IOS Active (enable/disable razor pay)</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 9)} value={setting?.razorpayIosEnabled} />
                </div>
                <div className="col-12 ">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="razorSecretKey" className="ms-2 order-1">
                      Razorpay Secret Key
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="razorSecretKey"
                      value={razorSecretKey}
                      placeholder={hasPermission ? "Enter Razorpay Secret Key" : "rzp_test_fakeSecretKey1234567890"}
                      onChange={(e) => {
                        setRazorSecretKey(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            razorSecretKey: ` Razorpay Secret Key Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            razorSecretKey: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.razorSecretKey}</p>}
                  </div>
                </div>
                <div className="col-12">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="razorPayId" className="ms-2 order-1">
                      RazorPay Id
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="razorPayId"
                      value={razorPayId}
                      placeholder={hasPermission ? `Enter RazorPay Id` : "rzp_test_1DP5mmOlF5G5ag"}
                      onChange={(e) => {
                        setRazorPayId(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            razorPayId: ` razorPay Id Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            razorPayId: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.razorPayId}</p>}
                  </div>
                </div>
                
              </div>
            </div>

            <div className="col-12 col-md-6 mt-3 ">
              <div className="settingBoxOuter">
                <div className="settingBoxHeader">
                  <h4>Stripe Pay Setting</h4>
                </div>
                <div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Stripe Pay Android Active (enable/disable stripe pay)</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 2)} value={setting?.isStripePay} />
                </div>

                <div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Stripe Pay IOS Active (enable/disable stripe pay)</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 8)} value={setting?.stripeIosEnabled} />
                </div>
                <div className="col-12 ">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="stripePublishableKey" className="ms-2 order-1">
                      Stripe Publishable Key
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="stripePublishableKey"
                      value={stripePublishableKey}
                      placeholder={hasPermission ? "Enter Stripe Publishable Key" : `pk_test_51H8bQ9L5ZtMn7EXAMPLE`}
                      onChange={(e) => {
                        setStripePublishableKey(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            stripePublishableKey: ` stripePublishableKey Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            stripePublishableKey: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.stripePublishableKey}</p>}
                  </div>
                </div>
                <div className="col-12">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="stripeSecretKey" className="ms-2 order-1">
                      Stripe Secret Key
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="stripeSecretKey"
                      value={stripeSecretKey}
                      placeholder={hasPermission ? "Enter Stripe Secret Key" : "sk_test_51H8bQ9L5ZtMn7EXAMPLE"}
                      onChange={(e) => {
                        setStripeSecretKey(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            stripeSecretKey: ` Stripe Secret Key Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            stripeSecretKey: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.stripeSecretKey}</p>}
                  </div>
                </div>
                
              </div>
            </div>
            <div className="col-12 col-md-6 mt-3 ">
              <div className="settingBoxOuter">
                <div className="settingBoxHeader">
                  <h4>Flutter Wave Setting</h4>
                </div>
<div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Flutterwawe enable disable</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 4)} value={setting?.isFlutterWave} />
                </div>
                <div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Flutterwawe Android enable disable</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 10)} value={setting?.flutterwaveIosEnabled} />
                </div>
                <div className="col-12">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="flutterWaveKey" className="ms-2 order-1">
                      FlutterWave Key
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="flutterWaveKey"
                      value={flutterWaveKey}
                      placeholder={hasPermission ? `Enter FlutterWave Key` : "FLWSECK_TEST-xxxxxxxxxxxxxxxxxxxxx-X"}
                      onChange={(e) => {
                        setFlutterWaveKey(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            flutterWaveKey: `FlutterWave Key Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            flutterWaveKey: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.flutterWaveKey}</p>}
                  </div>
                </div>
                
              </div>
            </div>

            <div className="col-12 col-md-6 mt-3 ">
              <div className="settingBoxOuter">
                <div className="settingBoxHeader">
                  <h4>Pay Stack Setting</h4>
                </div>
                <div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Pay Stack Android Active (enable/disable pay stack)</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 11)} value={setting?.paystackAndroidEnabled} />
                </div>

                <div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Pay Stack IOS Active (enable/disable pay stack)</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 12)} value={setting?.paystackIosEnabled} />
                </div>
                <div className="col-12 ">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="paystackPublicKey" className="ms-2 order-1">
                      Paystack Public Key
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="paystackPublicKey"
                      value={paystackPublicKey}
                      placeholder={hasPermission ? "Enter Paystack Public Key" : `pk_test_51H8bQ9L5ZtMn7EXAMPLE`}
                      onChange={(e) => {
                        setPaystackPublicKey(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            paystackPublicKey: ` Paystack Public Key Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            paystackPublicKey: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.paystackPublicKey}</p>}
                  </div>
                </div>
                <div className="col-12">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="paystackSecretKey" className="ms-2 order-1">
                      Pay Stack Secret Key
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="paystackSecretKey"
                      value={paystackSecretKey}
                      placeholder={hasPermission ? "Enter Pay Stack Secret Key" : "sk_test_51H8bQ9L5ZtMn7EXAMPLE"}
                      onChange={(e) => {
                        setPaystackSecretKey(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            paystackSecretKey: ` Pay Stack Secret Key Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            paystackSecretKey: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.paystackSecretKey}</p>}
                  </div>
                </div>
                
              </div>
            </div>

            <div className="col-12 col-md-6 mt-3 ">
              <div className="settingBoxOuter">
                <div className="settingBoxHeader">
                  <h4>Cashfree Setting</h4>
                </div>
                <div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Pay Stack Android Active (enable/disable pay stack)</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 13)} value={setting?.cashfreeAndroidEnabled} />
                </div>

                <div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Pay Stack IOS Active (enable/disable pay stack)</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 14)} value={setting?.cashfreeIosEnabled} />
                </div>
                <div className="col-12 ">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="cashfreeClientId" className="ms-2 order-1">
                      Cashfree Client Id
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="cashfreeClientId"
                      value={cashfreeClientId}
                      placeholder={hasPermission ? "Enter Cashfree Client Id" : `pk_test_51H8bQ9L5ZtMn7EXAMPLE`}
                      onChange={(e) => {
                        setCashfreeClientId(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            cashfreeClientId: ` Cashfree Client Id Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            cashfreeClientId: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.cashfreeClientId}</p>}
                  </div>
                </div>
                <div className="col-12">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="cashfreeClientSecret" className="ms-2 order-1">
                      Cashfree Client Secret
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="cashfreeClientSecret"
                      value={cashfreeClientSecret}
                      placeholder={hasPermission ? "Enter Cashfree Client Secret" : "sk_test_51H8bQ9L5ZtMn7EXAMPLE"}
                      onChange={(e) => {
                        setCashfreeClientSecret(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            cashfreeClientSecret: ` Pay Cashfree Client Secret Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            cashfreeClientSecret: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.cashfreeClientSecret}</p>}
                  </div>
                </div>
                
              </div>
            </div>

            <div className="col-12 col-md-6 mt-3 ">
              <div className="settingBoxOuter">
                <div className="settingBoxHeader">
                  <h4>Paypal Setting</h4>
                </div>
                <div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Pay Stack Android Active (enable/disable pay stack)</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 15)} value={setting?.paypalAndroidEnabled} />
                </div>

                <div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Pay Stack IOS Active (enable/disable pay stack)</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 16)} value={setting?.paypalIosEnabled} />
                </div>
                <div className="col-12 ">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="paypalClientId" className="ms-2 order-1">
                      Paypal Client Id
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="paypalClientId"
                      value={paypalClientId}
                      placeholder={hasPermission ? "Enter Paypal Client Id" : `pk_test_51H8bQ9L5ZtMn7EXAMPLE`}
                      onChange={(e) => {
                        setPaypalClientId(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            paypalClientId: ` Paypal Client Id Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            paypalClientId: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.paypalClientId}</p>}
                  </div>
                </div>
                <div className="col-12">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="paypalSecretKey" className="ms-2 order-1">
                      Paypal Client Secret
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="paypalSecretKey"
                      value={paypalSecretKey}
                      placeholder={hasPermission ? "Enter Paypal Client Secret" : "sk_test_51H8bQ9L5ZtMn7EXAMPLE"}
                      onChange={(e) => {
                        setPaypalSecretKey(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            paypalSecretKey: ` Pay Paypal Client Secret Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            paypalSecretKey: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.paypalSecretKey}</p>}
                  </div>
                </div>
                
              </div>
            </div>

            <div className="col-12 col-md-6 mt-3 ">
              <div className="settingBoxOuter">
                <div className="settingBoxHeader">
                  <h4>Google Play Setting</h4>
                </div>
                <div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Pay Stack Android Active (enable/disable pay stack)</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 6)} value={setting?.isGooglePlay} />
                </div>

                <div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Pay Stack IOS Active (enable/disable pay stack)</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 7)} value={setting?.googlePlayIosEnabled} />
                </div>
                <div className="col-12 ">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="googlePlayEmail" className="ms-2 order-1">
                      Google Play Email
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="googlePlayEmail"
                      value={googlePlayEmail}
                      placeholder={hasPermission ? "Enter Google Play Email" : `pk_test_51H8bQ9L5ZtMn7EXAMPLE`}
                      onChange={(e) => {
                        setGooglePlayEmail(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            googlePlayEmail: ` Google Play Email Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            googlePlayEmail: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.googlePlayEmail}</p>}
                  </div>
                </div>
                <div className="col-12">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="googlePlayKey" className="ms-2 order-1">
                      Google Play Key
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="googlePlayKey"
                      value={googlePlayKey}
                      placeholder={hasPermission ? "Enter Google Play Key" : "sk_test_51H8bQ9L5ZtMn7EXAMPLE"}
                      onChange={(e) => {
                        setGooglePlayKey(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            googlePlayKey: ` Pay Google Play Key Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            googlePlayKey: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.googlePlayKey}</p>}
                  </div>
                </div>
                
              </div>
            </div>

            <div className="col-12 col-md-6 mt-3 ">
              <div className="settingBoxOuter">
                <div className="settingBoxHeader">
                  <h4>Now Payment Setting</h4>
                </div>
                <div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Now Payment Android Active (enable/disable now payment)</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 17)} value={setting?.nowPaymentAndroidEnabled} />
                </div>

                <div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Now Payment IOS Active (enable/disable now payment)</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 18)} value={setting?.nowPaymentIosEnabled} />
                </div>

                <div className="inputData col-12 d-flex align-items-center justify-content-between">
                  <div>
                    <label className="my-3">Now Payment Is Test (enable/disable test mode)</label>
                  </div>
                  <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 19)} value={setting?.nowPaymentIsTest} />
                </div>

                <div className="col-12 ">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="nowPaymentApiKey" className="ms-2 order-1">
                      Now Payment API Key
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="nowPaymentApiKey"
                      value={nowPaymentApiKey}
                      placeholder={hasPermission ? "Enter Now Payment API Key" : `pk_test_51H8bQ9L5ZtMn7EXAMPLE`}
                      onChange={(e) => {
                        setNowPaymentApiKey(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            nowPaymentApiKey: ` Now Payment API Key Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            nowPaymentApiKey: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.nowPaymentApiKey}</p>}
                  </div>
                </div>
                <div className="col-12">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="nowPaymentSandboxKey" className="ms-2 order-1">
                      Now Payment Sandbox Key
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="nowPaymentSandboxKey"
                      value={nowPaymentSandboxKey}
                      placeholder={hasPermission ? "Enter Now Payment Sandbox Key" : "sk_test_51H8bQ9L5ZtMn7EXAMPLE"}
                      onChange={(e) => {
                        setNowPaymentSandboxKey(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            nowPaymentSandboxKey: ` Now Payment Sandbox Key Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            nowPaymentSandboxKey: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.nowPaymentSandboxKey}</p>}
                  </div>
                </div>

                <div className="col-12">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="nowPaymentIpnSecret" className="ms-2 order-1">
                      Now Payment IPN Secret
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="nowPaymentIpnSecret"
                      value={nowPaymentIpnSecret}
                      placeholder={hasPermission ? "Enter Now Payment IPN Secret" : "sk_test_51H8bQ9L5ZtMn7EXAMPLE"}
                      onChange={(e) => {
                        setNowPaymentIpnSecret(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            nowPaymentIpnSecret: ` Now Payment IPN Secret Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            nowPaymentIpnSecret: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.nowPaymentIpnSecret}</p>}
                  </div>
                </div>

                <div className="col-12">
                  <div className="inputData text  flex-row justify-content-start text-start">
                    <label htmlFor="nowPaymentPayCurrency" className="ms-2 order-1">
                      Now Payment Pay Currency
                    </label>
                    <input
                      type="text"
                      className="rounded-2"
                      id="nowPaymentPayCurrency"
                      value={nowPaymentPayCurrency}
                      placeholder={hasPermission ? "Enter Now Payment Pay Currency" : "usd"}
                      onChange={(e) => {
                        setNowPaymentPayCurrency(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            nowPaymentPayCurrency: ` Now Payment Pay Currency Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            nowPaymentPayCurrency: "",
                          });
                        }
                      }}
                    />
                    {error && <p className="errorMessage text-start">{error && error?.nowPaymentPayCurrency}</p>}
                  </div>
                </div>
                
              </div>
            </div>
          </>
        );

      case 2: {
        return (
          <>
            <div className="col-12 col-md-6 mt-3">
              <div className="settingBoxOuter">
                <div className="settingBoxHeader">
                  <h4>Firebase Notification Setting</h4>
                </div>
                <div className="inputData text flex-row justify-content-start text-start">
                  <label className="float-left" htmlFor="firebaseKey">
                    Private Key JSON
                  </label>
                  <textarea
                    name="firebaseKey"
                    className="mt-2"
                    id="firebaseKey"
                    rows={10}
                    value={firebaseKey}
                    placeholder={hasPermission ? `Enter firebaseKey` : JSON.stringify(fakeFirebaseJson, null, 2)}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      try {
                        JSON.parse(newValue);
                        setfirebaseKey(newValue);
                        setError({ ...error, firebaseKey: "" });
                      } catch (error) {
                        setfirebaseKey(newValue);
                        setError({
                          ...error,
                          firebaseKey: "Invalid JSON input",
                        });
                      }
                    }}
                  />
                  {error.firebaseKey && <p className="errorMessage">{error.firebaseKey}</p>}
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 mt-3">
              <div className="settingBoxOuter">
                <div className="settingBoxHeader">
                  <h4>Email Setting</h4>
                </div>
                <div className="inputData text flex-row justify-content-start text-start">
                  <label className="float-left" htmlFor="firebaseKey">
                    Resend API key
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="resendKey"
                    value={resendKey}
                    placeholder={hasPermission ? `Enter Resend API key` : `re_HDDJFDJdjf63742349djfbjd3dfnd`}
                    onChange={(e) => {
                      setResendKey(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          resendKey: ` Resend Key Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          resendKey: "",
                        });
                      }
                    }}
                  />
                  {error && <p className="errorMessage text-start">{error && error?.resendKey}</p>}
                </div>
              </div>
            </div>
          </>
        );
      }

      case 3: {
        return (
          <div className="col-12 col-md-6 mt-3 ">
            <div className="settingBoxOuter">
              <div className="settingBoxHeader">
                <h4>Currency Setting</h4>
              </div>

              <div className="col-12">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="currencyName" className="ms-2 order-1">
                    Currency Name
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="currencyName"
                    value={currencyName}
                    placeholder={hasPermission ? "Enter currency Name" : "USD"}
                    onChange={(e) => {
                      setCurrencyName(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          currencyName: ` currency Name Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          currencyName: "",
                        });
                      }
                    }}
                  />
                  {error && <p className="errorMessage text-start">{error && error?.currencyName}</p>}
                </div>
              </div>
              <div className="col-12">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="currencySymbol" className="ms-2 order-1">
                    Currency Symbol
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="currencySymbol"
                    value={currencySymbol}
                    placeholder={hasPermission ? "Enter Currency Symbol" : "$"}
                    onChange={(e) => {
                      setCurrencySymbol(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          currencySymbol: ` Currency Symbol Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          currencySymbol: "",
                        });
                      }
                    }}
                  />
                  {error && <p className="errorMessage text-start">{error && error?.currencySymbol}</p>}
                </div>
              </div>
              <div className="inputData">
                <div>
                  <label className="my-3">Cash After Service</label>
                </div>
                <ToggleSwitch onClick={() => handleSettingSwitch(setting?._id, 5)} value={setting?.cashAfterService} />
              </div>
            </div>
          </div>
        );
      }
    }
  };

  return (
    <div className="mainSetting">
      <Title name="Setting" />
      <div className="settingBox">
        <div className=" d-flex justify-content-end">
          <div className="  formFooter">
            <Button type={`submit`} className={`text-light m10-left fw-bold`} text={`Submit`} style={{ backgroundColor: "#1ebc1e" }} onClick={onsubmit} />
          </div>
        </div>
        <div>
          <div className="d-flex col-10 mt-auto mb-0">
            <div
              className="my-2 w-60  text-center  "
              style={{
                // width : "430px",
                border: "1px solid #1c2b20",
                padding: "2px",
                borderRadius: "40px",
              }}
            >
              <button type="button" className={`${person === 0 ? "activeBtn" : "disabledBtn"}`} onClick={() => setPerson(0)}>
                General
              </button>
              <button type="button" className={`${person === 1 ? "activeBtn" : "disabledBtn"} ms-1`} onClick={() => setPerson(1)}>
                Payment
              </button>
              <button type="button" className={`${person === 2 ? "activeBtn" : "disabledBtn"} ms-1`} onClick={() => setPerson(2)}>
                Firebase
              </button>
              <button type="button" className={`${person === 3 ? "activeBtn" : "disabledBtn"} ms-1`} onClick={() => setPerson(3)}>
                Currency
              </button>
            </div>
          </div>
        </div>

        

        {/* <div className="row">
          <div className="col-12 col-md-6 mt-3">
            <div className="settingBoxOuter">
              <div className="settingBoxHeader d-flex justify-content-between">
                <h4>App Setting</h4>
                <div className="inputData">
                  <label className="me-2">Maintenance Mode (use at the time of app maintanance)</label>
                  <ToggleSwitch
                    onClick={() => handleAppActive(setting?._id)}
                    value={setting?.maintenanceMode}
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="privacyPolicyLink" className="ms-2 order-1">
                    Privacy Policy Link (redirect user to this link when click on privacy policy in app)
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="privacyPolicyLink"
                    value={privacyPolicyLink}
                    placeholder="Enter privacyPolicyLink"
                    onChange={(e) => {
                      setPrivacyPolicyLink(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          privacyPolicyLink: ` privacyPolicyLink Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          privacyPolicyLink: "",
                        });
                      }
                    }}
                  />
                  {error && (
                    <p className="errorMessage text-start">
                      {error && error?.privacyPolicyLink}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-12">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="tnc" className="ms-2 order-1">
                    Terms and conditions content
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="tnc"
                    value={tnc}
                    placeholder="Enter tnc"
                    onChange={(e) => {
                      setTnc(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          tnc: ` Terms And Condition Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          tnc: "",
                        });
                      }
                    }}
                  />
                  {error && (
                    <p className="errorMessage text-start">
                      {error && error?.tnc}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-12 ">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="tax" className="ms-2 order-1">
                    Tax (%)
                  </label>
                  <input
                    type="number"
                    className="rounded-2"
                    id="tax"
                    value={tax}
                    placeholder="Enter tax"
                    onChange={(e) => {
                      setTax(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          tax: ` tax Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          tax: "",
                        });
                      }
                    }}
                  />
                  {error && (
                    <p className="errorMessage text-start">
                      {error && error?.tax}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 mt-3 ">
            <div className="settingBoxOuter">
              <div className="settingBoxHeader">
                <h4>Razor Pay Setting</h4>
              </div>
              <div className="col-12 ">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="razorSecretKey" className="ms-2 order-1">
                    Razorpay Secret Key
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="razorSecretKey"
                    value={razorSecretKey}
                    placeholder="Enter Razorpay Secret Key"
                    onChange={(e) => {
                      setRazorSecretKey(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          razorSecretKey: ` Razorpay Secret Key Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          razorSecretKey: "",
                        });
                      }
                    }}
                  />
                  {error && (
                    <p className="errorMessage text-start">
                      {error && error?.razorSecretKey}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-12">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="razorPayId" className="ms-2 order-1">
                    RazorPay Id
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="razorPayId"
                    value={razorPayId}
                    placeholder="Enter razorPay Id"
                    onChange={(e) => {
                      setRazorPayId(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          razorPayId: ` razorPay Id Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          razorPayId: "",
                        });
                      }
                    }}
                  />
                  {error && (
                    <p className="errorMessage text-start">
                      {error && error?.razorPayId}
                    </p>
                  )}
                </div>
              </div>
              <div className="inputData">
                <div>
                  <label className="my-3">Razor Pay Active (enable/disable razor pay)</label>
                </div>
                <ToggleSwitch
                  onClick={() => handleSettingSwitch(setting?._id, 1)}
                  value={setting?.isRazorPay}
                />
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 mt-3 ">
            <div className="settingBoxOuter">
              <div className="settingBoxHeader">
                <h4>Stripe Pay Setting</h4>
              </div>
              <div className="col-12 ">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label
                    htmlFor="stripePublishableKey"
                    className="ms-2 order-1"
                  >
                    Stripe Publishable Key
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="stripePublishableKey"
                    value={stripePublishableKey}
                    placeholder="Enter Stripe Publishable Key"
                    onChange={(e) => {
                      setStripePublishableKey(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          stripePublishableKey: ` stripePublishableKey Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          stripePublishableKey: "",
                        });
                      }
                    }}
                  />
                  {error && (
                    <p className="errorMessage text-start">
                      {error && error?.stripePublishableKey}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-12">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="stripeSecretKey" className="ms-2 order-1">
                    Stripe Secret Key
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="stripeSecretKey"
                    value={stripeSecretKey}
                    placeholder="Enter Stripe Secret Key"
                    onChange={(e) => {
                      setStripeSecretKey(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          stripeSecretKey: ` Stripe Secret Key Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          stripeSecretKey: "",
                        });
                      }
                    }}
                  />
                  {error && (
                    <p className="errorMessage text-start">
                      {error && error?.stripeSecretKey}
                    </p>
                  )}
                </div>
              </div>
              <div className="inputData">
                <div>
                  <label className="my-3">Stripe Pay Active (enable/disable stripe pay)</label>
                </div>
                <ToggleSwitch
                  onClick={() => handleSettingSwitch(setting?._id, 2)}
                  value={setting?.isStripePay}
                />
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 mt-3 ">
            <div className="settingBoxOuter">
              <div className="settingBoxHeader">
                <h4>Currency Setting</h4>
              </div>

              <div className="col-12">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="currencyName" className="ms-2 order-1">
                    Currency Name
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="currencyName"
                    value={currencyName}
                    placeholder="Enter currency Name"
                    onChange={(e) => {
                      setCurrencyName(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          currencyName: ` currency Name Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          currencyName: "",
                        });
                      }
                    }}
                  />
                  {error && (
                    <p className="errorMessage text-start">
                      {error && error?.currencyName}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-12">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="currencySymbol" className="ms-2 order-1">
                    Currency Symbol
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="currencySymbol"
                    value={currencySymbol}
                    placeholder="Enter Currency Symbol"
                    onChange={(e) => {
                      setCurrencySymbol(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          currencySymbol: ` Currency Symbol Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          currencySymbol: "",
                        });
                      }
                    }}
                  />
                  {error && (
                    <p className="errorMessage text-start">
                      {error && error?.currencySymbol}
                    </p>
                  )}
                </div>
              </div>
              <div className="inputData">
                <div>
                  <label className="my-3">Cash After Service</label>
                </div>
                <ToggleSwitch
                  onClick={() => handleSettingSwitch(setting?._id, 5)}
                  value={setting?.cashAfterService}
                />
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 mt-3 ">
            <div className="settingBoxOuter">
              <div className="settingBoxHeader">
                <h4>Firebase Notification Setting</h4>
              </div>

              <div className="inputData text  flex-row justify-content-start text-start">
                <label className="float-left" htmlFor="firebaseKey">
                  Private Key JSON (use for firebase push notification)
                </label>
                <textarea
                  name="firebaseKey"
                  className=" mt-2"
                  id="firebaseKey"
                  rows={10}
                  value={firebaseKey}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    try {
                      const newData = JSON.parse(newValue);
                      setfirebaseKey(newValue);
                      setError("");
                    } catch (error) {
                      // Handle invalid JSON input
                      console.error("Invalid JSON input:", error);
                      setfirebaseKey(newValue);
                      return setError({
                        ...error,
                        firebaseKey: "Invalid JSON input",
                      });
                    }
                  }}
                ></textarea>

                {error.firebaseKey && (
                  <div className="pl-1 text-left">
                    <p className="errorMessage">{error.firebaseKey}</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 mt-3 ">
            <div className="settingBoxOuter">
              <div className="settingBoxHeader">
                <h4>Flutter Wave Setting</h4>
              </div>

              <div className="col-12">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="flutterWaveKey" className="ms-2 order-1">
                    FlutterWave Key
                  </label>
                  <input
                    type="text"
                    className="rounded-2"
                    id="flutterWaveKey"
                    value={flutterWaveKey}
                    placeholder="EnterFlutterWave Key"
                    onChange={(e) => {
                      setFlutterWaveKey(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          flutterWaveKey: `FlutterWave Key Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          flutterWaveKey: "",
                        });
                      }
                    }}
                  />
                  {error && (
                    <p className="errorMessage text-start">
                      {error && error?.flutterWaveKey}
                    </p>
                  )}
                </div>
              </div>
              <div className="inputData">
                <div>
                  <label className="my-3">Flutterwawe enable disable</label>
                </div>
                <ToggleSwitch
                  onClick={() => handleSettingSwitch(setting?._id, 4)}
                  value={setting?.isFlutterWave}
                />
              </div>
            </div>
          </div>
        </div> */}
        <div className="row">{renderfnc()}</div>
      </div>
    </div>
  );
};
export default Setting;
